import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motion-easing',
  templateUrl: './motion-easing.component.html',
  styleUrls: ['./motion-easing.component.sass']
})
export class MotionEasingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
